import { FC, HTMLProps } from 'react';
import s from './loader.module.css';
import cn from 'classnames';
import { SizeType } from '../../types/props';

export interface LoaderProps extends Omit<HTMLProps<HTMLDivElement>, 'size'> {
  size?: SizeType;
}

export const Loader: FC<LoaderProps> = (props) => {
  const { size = 'md', className, ...other } = props;

  return (
    <div
      className={cn(s.component, className, s[size])}
      data-testid={other.id}
      {...other}
      aria-busy
      role="alert"
    />
  );
};
